import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent } from 'fronton-react';
import { ButtonWithGAClickButton, ModalContentAction, ModalHeader, Typography } from 'common/components';
import { STORAGE_DESIGN_PROJECT_HREF, STORAGE_ELEMENT_BLOCK } from '../../../../storage-constants';

export const OnlineConstructorModal = () => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.online-constructor.card-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long">
          {t('utp-section.online-constructor.modal-description')}
        </Typography>
        <ModalContentAction>
          <ButtonWithGAClickButton
            adaptive={false}
            elementBlock={STORAGE_ELEMENT_BLOCK}
            elementText={t('design-panel.button-first')}
            elementName={t('utp-section.online-constructor.card-title')}
            href={STORAGE_DESIGN_PROJECT_HREF}
            wide>
            {t('design-panel.button-first')}
          </ButtonWithGAClickButton>
        </ModalContentAction>
      </ModalContent>
    </>
  );
};
